// import drrobert from '../api/drrobert'
// import auth from '../api/auth';
import apiurl from '../api/baseurl'
import Vue from 'vue'

//const firstlogininfo = require('@/assets/firstlogin.json')

const initialState = {
  configFile: null,
  server_env: 'PRO',
  webname: ''
}

const getters = {
  //isAuthenticated: state => !!state.token,
  getProperConfig: state => {
    if (state.configFile) return state.configFile.config[state.server_env]
    else return null
  },
  isInit: state => {
    if (state.configFile) return true
    else return false
  }
}

const actions = {
  getConfigFile: (context, { slug, force }) => {
    /*let responsePromise=  session.get(apiurl.navandume.proxy+'', {})
      responsePromise.then(({ data }) =>{
        context.commit('robertTerms', data)
      })setEnvironment
      return responsePromise */
    if (context.state.configFile === null || force === true) {
      //this.addCSS(process.env.BASE_URL + '/' + this.webname + '/site.css')
      return Vue.axios
        .get(process.env.BASE_URL + slug + '/site.json')
        .then(response => {
          context.commit('setConfigFile', response.data)
          //let server_env = process.env.VUE_APP_ENVIRONMENT
          let server_env = context.state.server_env
          apiurl.navandume = response.data.config[server_env].navandume_url
          apiurl.proxy = response.data.config[server_env].proxy_url
          //apiurl.productTermNumber = response.data.config[server_env].productTermNumber
        })
    } else return Promise.resolve('')
  }
}

const mutations = {
  setConfigFile: (state, dat) => {
    state.configFile = dat
  },
  setServerEnv: (state, env) => {
    state.server_env = env
  },
  setWebname: (state, name) => {
    state.webname = name
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}
